export default {"src":"/_next/static/media/On.e4a9d31a.svg","height":16,"width":16};